(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[982],{

/***/ 11136:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landings/[...path]",
      function () {
        return __webpack_require__(55311);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   "pagePathView": function() { return /* binding */ pagePathView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69904);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96204);
/* harmony import */ var src_pages_builder_LandingHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99899);
/* harmony import */ var client_components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3066);
/* harmony import */ var src_pages_builder_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3977);
/* harmony import */ var client_contexts_Tracking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54168);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_pages_builder_builderUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64972);
/* harmony import */ var src_context_search__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33500);
/* harmony import */ var src_comps_Page__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77288);
/* harmony import */ var src_context_topDestinations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27606);













(0,src_pages_builder_builderUtils__WEBPACK_IMPORTED_MODULE_7__/* .registerBuilderComponents */ .l)();
var pagePathView = "/landings/[...path]";
var __N_SSP = true;

var pageId = "landings";
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    var config = props.config, builderContent = props.builderContent, amazingDestinations = props.amazingDestinations;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().query;
    (0,react_use__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
        (0,client_contexts_Tracking__WEBPACK_IMPORTED_MODULE_12__/* .dataLayerPush */ .l)([
            {
                eventName: "update_utm_values",
                sfl: {
                    utm_campaign: query.utm_campaign,
                    utm_source: query.utm_source,
                    utm_medium: query.utm_medium,
                    utm_content: query.utm_content
                }
            }, 
        ]);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Page__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        config: config,
        pageId: pageId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_context_search__WEBPACK_IMPORTED_MODULE_8__/* .SearchProvider */ .X, {
            location: null,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_context_topDestinations__WEBPACK_IMPORTED_MODULE_10__/* .TopDestinationsProvider */ .I, {
                value: {
                    destinations: amazingDestinations
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_pages_builder_LandingHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_pages_builder_styles__WEBPACK_IMPORTED_MODULE_5__/* .LandingsContainer */ .f, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .BuilderComponent */ .VD, {
                                locale: config.locale,
                                model: "page",
                                content: builderContent
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 99899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/comps/OmniSearch/index.tsx + 1 modules
var OmniSearch = __webpack_require__(77427);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/hooks/useSearch.ts
var useSearch = __webpack_require__(36796);
// EXTERNAL MODULE: ./src/types/device.ts
var device = __webpack_require__(68686);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(66334);
// EXTERNAL MODULE: ./client/components/HeaderWithSlots/index.tsx + 7 modules
var HeaderWithSlots = __webpack_require__(21103);
// EXTERNAL MODULE: ./client/components/HeaderLogo/index.tsx + 11 modules
var HeaderLogo = __webpack_require__(17379);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/LoginNavigator/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    position: absolute;\n    inset-block-start: 38px;\n    z-index: var(--z-high);\n    background-color: ",
        ";\n    inset-inline-start: calc(100% - 170px);\n    width: 200px;\n    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n  border-block-end: 1px solid ",
        ";\n\n  > h3 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-block-end: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  li {\n    border-block-end: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 500;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: block;\n  padding-block: 16px;\n  padding-inline: 16px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var LoginNavigatorBase = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__LoginNavigatorBase",
    componentId: "sc-adc88f8-0"
})(_templateObject(), styles/* media.tablet */.BC.tablet, styles/* colors.white */.O9.white);
var NavigatorHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NavigatorHeader",
    componentId: "sc-adc88f8-1"
})(_templateObject1(), styles/* colors.grey6 */.O9.grey6);
var NavigatorList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__NavigatorList",
    componentId: "sc-adc88f8-2"
})(_templateObject2(), styles/* colors.grey6 */.O9.grey6);
var Section = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__Section",
    componentId: "sc-adc88f8-3"
})(_templateObject5(), styles/* colors.grey6 */.O9.grey6, function(props) {
    return props.id === "link" && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), styles/* colors.white */.O9.white, styles/* colors.grey1 */.O9.grey1);
}, function(props) {
    return props.id === "logout" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), styles/* colors.white */.O9.white, styles/* colors.red */.O9.red);
});

;// CONCATENATED MODULE: ./src/comps/LoginButton/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  position: relative;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: var(--color--base--white);\n    "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 21px;\n  line-height: 21px;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: ",
        ";\n  color: var(--color--neutral--800);\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color--neutral--600);\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color--text--link--on-light);\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    text-decoration: none;\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var LoginButtonBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoginButtonBase",
    componentId: "sc-92e25e12-0"
})(styles_templateObject());
var LoginButtonLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LoginButtonLink",
    componentId: "sc-92e25e12-1"
})(styles_templateObject1());
var LoginLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoginLabel",
    componentId: "sc-92e25e12-2"
})(styles_templateObject3(), styles/* fonts.default */.Rq["default"], function(props) {
    return props.isEbooking && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2());
});
var CheckoutLabel = (0,styled_components_browser_esm/* default */.ZP)(LoginLabel).withConfig({
    displayName: "styles__CheckoutLabel",
    componentId: "sc-92e25e12-3"
})(styles_templateObject4());
var LoginTextLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LoginTextLink",
    componentId: "sc-92e25e12-4"
})(styles_templateObject5());

;// CONCATENATED MODULE: ./client/components/MinimalHeader/styles.tsx

function MinimalHeader_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: flex-end;\n  position: relative;\n  gap: 8px;\n\n  ",
        " {\n    ",
        " {\n      position: absolute;\n      inset-block-start: 38px;\n      z-index: var(--z-high);\n      background-color: ",
        ";\n    }\n\n    ",
        " {\n      inset-inline-start: calc(100% - 170px);\n      width: 200px;\n      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);\n    }\n  }\n  ",
        " {\n    gap: 16px;\n  }\n"
    ]);
    MinimalHeader_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MinimalHeader_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        margin-inline-end: 0;\n      }\n    "
    ]);
    MinimalHeader_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MinimalHeader_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  ",
        "\n  ",
        " {\n    gap: 16px;\n  }\n\n  ",
        " {\n    height: 40px;\n  }\n"
    ]);
    MinimalHeader_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var UserActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__UserActions",
    componentId: "sc-c0ffd013-0"
})(MinimalHeader_styles_templateObject(), styles/* media.tablet */.BC.tablet, LoginNavigatorBase, styles/* colors.white */.O9.white, LoginNavigatorBase, styles/* updatedMedia.tablet */.$c.tablet);
var RightSideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RightSideWrapper",
    componentId: "sc-c0ffd013-1"
})(MinimalHeader_styles_templateObject2(), function(param) {
    var isSearch = param.isSearch;
    return isSearch && (0,styled_components_browser_esm/* css */.iv)(MinimalHeader_styles_templateObject1(), LoginButtonBase);
}, styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.desktop */.$c.desktop);

// EXTERNAL MODULE: ./src/comps/LoginButton/index.tsx + 3 modules
var LoginButton = __webpack_require__(65559);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(38062);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./client/components/MinimalHeader/index.tsx













function MinimalHeader(props) {
    var center = props.center, bottom = props.bottom, fixed = props.fixed, pageId = props.pageId;
    var currentUserHasPrimeSubscription = (0,useSession/* useSession */.k)().currentUserHasPrimeSubscription;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var router = (0,next_router.useRouter)();
    var showLogo = function() {
        if (activeBreakpoint < device/* BreakpointSizes.M */.a.M) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                variant: "icon-rounded",
                size: "small",
                leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {}),
                onClick: router.back
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo/* default */.Z, {
            pageId: pageId,
            isPrime: currentUserHasPrimeSubscription
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithSlots/* default */.Z, {
        left: showLogo(),
        center: center,
        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSideWrapper, {
            isSearch: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserActions, {
                children: [
                    activeBreakpoint >= device/* BreakpointSizes.M */.a.M && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountrySelector/* CountrySelector */.P, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton/* default */.Z, {})
                ]
            })
        }),
        bottom: bottom,
        fixed: fixed
    });
}
/* harmony default export */ var components_MinimalHeader = (MinimalHeader);

// EXTERNAL MODULE: ./client/components/OmniSearchHeader/styles.module.css
var styles_module = __webpack_require__(5304);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./client/components/OmniSearchHeader/index.tsx











var OmniSearchSmall = function(param) {
    var searchUrl = param.searchUrl, preventNavigation = param.preventNavigation, onClick = param.onClick;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
        snapPoints: [],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Trigger */.R1.Trigger, {
                className: (styles_module_default()).omnisearchSmall,
                "data-testid": "omnisearch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                    mode: search/* SearchMode.Readonly */.N3.Readonly,
                    searchUrl: searchUrl,
                    preventNavigation: preventNavigation
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                title: intl.formatMessage({
                    id: "modify.search"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                    mode: search/* SearchMode.Full */.N3.Full,
                    searchUrl: searchUrl,
                    preventNavigation: preventNavigation,
                    onClick: onClick
                })
            })
        ]
    });
};
function OmniSearchHeader(props) {
    var ref = (0,useSearch/* useSearch */.R)(), newSearchUrl = ref.searchUrl;
    var bottom = props.bottom, pageId = props.pageId, fixed = props.fixed, preventNavigation = props.preventNavigation, _searchUrl = props.searchUrl, searchUrl = _searchUrl === void 0 ? newSearchUrl : _searchUrl;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var render = /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearchSmall, {
        searchUrl: searchUrl,
        preventNavigation: preventNavigation
    });
    if (activeBreakpoint >= device/* BreakpointSizes.L */.a.L) {
        render = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).omnisearchLarge,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                searchUrl: searchUrl,
                mode: search/* SearchMode.Borderless */.N3.Borderless,
                preventNavigation: preventNavigation,
                smallBtn: true
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MinimalHeader, {
        center: render,
        bottom: bottom,
        pageId: pageId,
        fixed: fixed
    });
}
/* harmony default export */ var components_OmniSearchHeader = (OmniSearchHeader);

;// CONCATENATED MODULE: ./src/pages/builder/LandingHeader/index.tsx





var pageId = routes/* routes.landings.page */._.landings.page;
var LandingsHeader = function() {
    var oldSearchUrl = (0,useSearch/* useSearch */.R)().oldSearchUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OmniSearchHeader, {
        pageId: pageId,
        bottom: null,
        fixed: true,
        preventNavigation: false,
        searchUrl: oldSearchUrl
    });
};
/* harmony default export */ var LandingHeader = (LandingsHeader);


/***/ }),

/***/ 64972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ registerBuilderComponents; }
/* harmony export */ });
/* unused harmony export getBuilderPageContent */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96204);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_constants_subscriptionSources__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4077);





var getBuilderPageContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(url, locale) {
        var builderContent;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .builder.get */ .fl.get("page", {
                            url: url,
                            options: {
                                locale: locale
                            },
                            userAttributes: {
                                locale: locale
                            },
                            includeUnpublished: true
                        }).toPromise()
                    ];
                case 1:
                    builderContent = _state.sent();
                    return [
                        2,
                        builderContent
                    ];
            }
        });
    });
    return function getBuilderPageContent(url, locale) {
        return _ref.apply(this, arguments);
    };
}();
var registerBuilderComponents = function() {
    // Factorial open positions component
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 9365).then(__webpack_require__.bind(__webpack_require__, 59365));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(59365)
                ];
            }
        }
    }), {
        name: "FactorialOpenPositions",
        inputs: [
            {
                name: "width",
                type: "string",
                defaultValue: "100%"
            },
            {
                name: "height",
                type: "string",
                defaultValue: "100%"
            }, 
        ]
    });
    // external link
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent((0,_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .withChildren */ .u7)(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 1933).then(__webpack_require__.bind(__webpack_require__, 41933));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(41933)
                ];
            }
        }
    })), {
        name: "LinkBlock",
        inputs: [
            {
                name: "url",
                type: "string",
                defaultValue: ""
            },
            {
                name: "target",
                type: "string",
                defaultValue: "_self",
                enum: [
                    "_self",
                    "_blank",
                    "_parent",
                    "_top"
                ]
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.SubscriptionBox;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    }), {
        name: "NewsletterBox",
        inputs: [
            {
                name: "source",
                type: "string",
                defaultValue: src_constants_subscriptionSources__WEBPACK_IMPORTED_MODULE_4__/* .SUBSCRIPTION_BOX_LANDINGS_PAGE */ .aE,
                localized: true
            },
            {
                name: "variant",
                type: "text",
                enum: [
                    "box",
                    "section",
                    "minimal"
                ],
                defaultValue: "section",
                helperText: "box/section: Full customization. minimal: Only input + button (no title/description/background)"
            },
            {
                name: "title",
                type: "string",
                localized: true,
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Custom title (uses default translation if empty)"
            },
            {
                name: "description",
                type: "string",
                localized: true,
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Custom description (uses default translation if empty)"
            },
            {
                name: "bgColor",
                type: "color",
                defaultValue: "#B494F9",
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Container background color"
            },
            {
                name: "buttonText",
                type: "string",
                localized: true,
                helperText: "Custom button text (uses default translation if empty)"
            },
            {
                name: "buttonBgColor",
                type: "color",
                helperText: "Custom button background color (uses default if empty)"
            },
            {
                name: "buttonTextColor",
                type: "color",
                helperText: "Custom button text color (uses default if empty)"
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent((0,_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .withChildren */ .u7)(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.BannerProperties;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    })), {
        name: "BannerProperties",
        inputs: [
            {
                name: "bannerId",
                type: "string",
                defaultValue: ""
            },
            {
                name: "checkInOffset",
                type: "number",
                defaultValue: 0,
                min: 0,
                helperText: "Number of days to add to the check-in date from today (TTC)"
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.TopDestinations.Connected;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    }), {
        name: "BannerDestinations",
        inputs: [
            {
                name: "bannerId",
                type: "string",
                defaultValue: ""
            }
        ]
    });
};


/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingsContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a {\n    text-decoration: none;\n  }\n\n  margin-block-start: 57px;\n\n  ",
        " {\n    margin-block-start: 65px;\n  }\n\n  ",
        " {\n    margin-block-start: 89px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LandingsContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__LandingsContainer",
    componentId: "sc-3229c455-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.tablet */ .$c.tablet, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.desktop */ .$c.desktop);


/***/ }),

/***/ 5304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"omnisearchSmall":"styles_omnisearchSmall__8eIk2","omnisearchLarge":"styles_omnisearchLarge__co0NL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2522,3053,7427,9774,2888,179], function() { return __webpack_exec__(11136); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);